// Make Rich text section clickable
document.addEventListener('DOMContentLoaded', function() {
  const section = document.querySelector('#shopify-section-template--27004864069979__section_XNeL3N');
  if (section) {
    section.style.cursor = 'pointer';
    section.addEventListener('click', function(e) {
      // Don't trigger if clicking a link or button
      if (!e.target.closest('a, button')) {
        window.location.href = '/collections/hybrid-collection';
      }
    });
  }
});
